export class ConfirmationDialog {
  heading?: string;
  body?: string;
  yesButton?: string;
  noButton?: string;
  buttons?: any[];
  othersBtn?: boolean;
  type?: string;
}

export interface ConfirmationMsgDefault {
  [x: string]: ConfirmationDialog;
}
